//@flow
import React from 'react';
import * as Immutable from 'immutable';
import { SlotSelectionComponentWithPopover } from 'common/entity/components/dayShift/EntityWorkingDaysInput';
import WorkingDaysSelectorWithOffsetModal from './WorkingDaysSelectorWithOffsetModal';
import WorkingDaysSummary from 'common/entity/components/dayShift/WorkingDaysSummary';
import { memoizedImmutable } from 'common/utils/Memoizer';
import { type ThemeType } from 'react-css-themr';
import type { DayShift } from 'common/models/internal/DayShift';

type Props = {
    onChange: ?(Immutable.List<DayShift>) => void,
    workingDays: ?Immutable.List<DayShift>,
    defaultWorkingDays: ?Immutable.List<DayShift>,
    popOverContent: ?string,
    theme: ThemeType,
    translationsObject: {
        startLocationPlaceholder: string,
        endLocationPlaceholder: string
    }
};

type State = {
    isWorkingDaysSelectorVisible: boolean
};

export default class EntityWorkingDaysInputWithOffset extends React.Component<
    Props,
    State
> {
    state = {
        isWorkingDaysSelectorVisible: false
    };

    onShowWorkingDaysSelector = () => {
        this.setState({ isWorkingDaysSelectorVisible: true });
    };

    onHideWorkingDaysSelector = () => {
        this.setState({ isWorkingDaysSelectorVisible: false });
    };

    handleWorkingDaysChange = (workingDays: Array<DayShift>) => {
        const { onChange } = this.props;
        onChange?.(Immutable.List(workingDays));
    };

    @memoizedImmutable()
    getDefaultWorkingDays(
        workingDays: ?Immutable.List<DayShift>
    ): Array<DayShift> {
        if (workingDays) {
            return workingDays.toArray();
        } else {
            // If workingDays are not there, we dont want to show default workingDays in slot selector,
            // hence init to empty array
            return [];
        }
    }

    render() {
        const {
            workingDays,
            defaultWorkingDays,
            popOverContent,
            theme,
            translationsObject
        } = this.props;
        const {
            startLocationPlaceholder,
            endLocationPlaceholder
        } = translationsObject;
        const { isWorkingDaysSelectorVisible } = this.state;

        return (
            <>
                <WorkingDaysSummary slots={workingDays} isBreaksWithOffset />
                <SlotSelectionComponentWithPopover
                    theme={theme}
                    translationsObject={translationsObject}
                    defaultWorkingDays={defaultWorkingDays}
                    onClick={this.onShowWorkingDaysSelector}
                    popOverContent={popOverContent}
                    isPopOverOpen={
                        !!popOverContent && !isWorkingDaysSelectorVisible
                    }
                />
                {isWorkingDaysSelectorVisible ? (
                    <WorkingDaysSelectorWithOffsetModal
                        startLocationPlaceholder={startLocationPlaceholder}
                        endLocationPlaceholder={endLocationPlaceholder}
                        theme={theme}
                        defaultWorkingDays={this.getDefaultWorkingDays(
                            defaultWorkingDays
                        )}
                        onDismiss={this.onHideWorkingDaysSelector}
                        onWorkingDaysApply={this.handleWorkingDaysChange}
                    />
                ) : null}
            </>
        );
    }
}
